import React, { useContext, useEffect, useRef } from 'react'
import { Root, createRoot } from 'react-dom/client'
import { ThemeContext, ThemeProvider } from 'styled-components'

interface Props {
  map: google.maps.Map | null;
  children: React.ReactNode;
  position: google.maps.LatLngLiteral;
  onClick: () => void;
  zIndex: number;
}

function AdvancedMarker(props: Props) {
  const { map, children, position, onClick, zIndex } = props
  const markerRef = useRef<google.maps.marker.AdvancedMarkerElement | null>(
    null,
  )
  const rootRef = useRef<Root | null>(null)

  const theme = useContext(ThemeContext)

  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.zIndex = zIndex
    }
  }, [zIndex])

  useEffect(() => {
    if (!rootRef.current) {
      const container = document.createElement('div')
      rootRef.current = createRoot(container)

      markerRef.current = new google.maps.marker.AdvancedMarkerElement({
        position,
        content: container,
        zIndex,
      })
      return () => {
        container?.remove()
        rootRef.current = null
        if (markerRef.current) {
          // this is how markers are deleted
          markerRef.current.map = null
        }
        markerRef.current = null
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // need to make theme context available to the children
    rootRef.current?.render(
      <ThemeProvider theme={theme}>{children}</ThemeProvider>,
    )
    if (markerRef.current) {
      markerRef.current.position = position
      markerRef.current.map = map
    }
    const listener = markerRef.current?.addListener('click', onClick)
    return () => listener?.remove()
  }, [map, position, children, onClick, theme])

  return null
}

export default AdvancedMarker
